import React from 'react';
import { Form, Input } from 'antd';
import { FormField } from '../../../interfaces/FormInterfaces';

const InputField = (props: FormField) => {
  return (
    <Form.Item
      name={props.name}
      rules={props.rules}
      style={props.styles}
      labelCol={{
        style: {
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
      }}
    >
      <Input
        placeholder={props.placeholder}
        {...props.otherprops}
        disabled={props.disabled}
        autoComplete="none"
      />
    </Form.Item>
  );
};

export default InputField;
